const Checkbox = ({
  label,
  name,
  value,
  onChange,
  checked,
  ...rest
}: {
  label: string;
  name: string;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
}) => {
  return (
    <input
      className="checkbox"
      type="checkbox"
      name={name}
      value={value}
      onChange={onChange}
      checked={checked}
      {...rest}
    />
  );
};

export default Checkbox;
